module.exports = __webpack_public_path__ + "static/img/siege_expert1.ce4c950.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/siege_expert1.png
// module id = +ktL
// module chunks = 0